import { render } from "./EditMandate.vue?vue&type=template&id=72c3d3b8&scoped=true"
import script from "./EditMandate.vue?vue&type=script&lang=js"
export * from "./EditMandate.vue?vue&type=script&lang=js"

import "./EditMandate.vue?vue&type=style&index=0&id=72c3d3b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c3d3b8"]])

export default __exports__